import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { DataStateChangeEvent, GridComponent, GridDataResult, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { ContactService } from 'src/app/contacts/contact.service';
import { AddAddressComponent } from '../add-address/add-address.component';
import { AppComponentBase } from '../app-component-base';
import { CommonService } from 'src/app-core/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { CommonDataModel } from '../common-data-model';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-address-list',
  templateUrl: './address-list.component.html',
  styleUrls: ['./address-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class AddressListComponent extends AppComponentBase implements OnInit {

  @ViewChild('grid', { static: true }) private grid: GridComponent;
  @Input() accountId: string;
  @Input() account: string;
  @Input() accountStatus: boolean;
  @Input() set accountDetailsParams(data: any) {
    this.accountDetails = data;
  }
  @Output() getCount: EventEmitter<number> = new EventEmitter<number>();
  @Output() getCountForPopup: EventEmitter<any> = new EventEmitter<any>();

  multiStatusUpdateModel = new CommonDataModel();
  statusUpdateModel = new CommonDataModel();
  searchQuery: string;
  rowSelectionList: string[] = [];
  multiUpdateModel = this.multiStatusUpdateModel.addressesStatusUpdateModel;
  UpdateModel = this.statusUpdateModel.addressesStatusUpdateModel;
  addressId: string;
  statusValue = 'true';
  selectAllState: SelectAllCheckboxState = 'unchecked';
  addressList: any;
  accountDetails: any;
  isUpdate: boolean = false;

  constructor(
    injector: Injector,
    private dialog: MatDialog,
    private contactService: ContactService,
    private router: Router,
    private commonService: CommonService,
    private toastr: ToastrService) {
    super(injector);
  }

  ngOnInit(): void {
    this.statusValue = `${this.accountDetails.activeStatus}`;
    this.onRefreshGridData();
  }

  onRefreshGridData(): void {
    this.kendogridHelper.defaultRecordsCountPerPage = 10;
    this.kendogridHelper.sort = [{ dir: 'asc', field: 'addressType' }];
    this.grid.dataStateChange.emit({
      skip: 0,
      take: this.kendogridHelper.defaultRecordsCountPerPage,
      filter: undefined,
      group: undefined,
      sort: this.kendogridHelper.sort,
    });
  }

  getGridRecords(event: DataStateChangeEvent): void {
    if (event) {
      this.kendogridHelper.dataStateChangeEvent(event);
    }
    this.kendogridHelper.showLoadingIndicator();
    const queryParams = this.accountDetails.accountId ? `&AccountId=${this.accountDetails.accountId}` : '';
    const gridStatus = `&IsActive= ${this.statusValue}`;
    this.contactService.getAddressesGridRecords(event, queryParams, gridStatus)
    .pipe(finalize(() => (this.kendogridHelper.hideLoadingIndicator()))).subscribe(response => {
      this.kendogridHelper.setGridData(response.data);
      this.addressList = response.data.items;
      this.getCount.emit(this.kendogridHelper.totalRecordsCount);
      this.getCountForPopup.emit({count: this.kendogridHelper.totalRecordsCount, isUpdate : this.isUpdate });
      this.selectAllState = 'unchecked';
      this.rowSelectionList = [];
      this.kendogridHelper.hideLoadingIndicator();
    });
  }

  onOpenDialog(): void {
    this.dialog.open(AddAddressComponent, {
      autoFocus: false,
      position: {
        right: '0',
      },
      panelClass: 'small_layout',
      hasBackdrop: false,
      data: { accountId: this.accountDetails.id, addressId: this.addressId },
    }).afterClosed()
      .subscribe((response: any) => {
        if (response) {
          this.isUpdate = true;
          this.onRefreshGridData();
        }
      });
  }

  onStatusUpdate(data: any) {
    this.UpdateModel.addresses = [];
    this.UpdateModel.addresses.push(data.addressId);
    this.commonService.objectMapping(this.UpdateModel, data);
    this.ChangeStatus(this.UpdateModel);
  }

  onMultiStatusUpdate() {
    this.multiUpdateModel.addresses = [];
    this.multiUpdateModel.addresses = this.rowSelectionList.filter(item => item != null);
    this.multiUpdateModel.isActive = this.statusValue === 'false' ? true : false;
    this.multiUpdateModel.accountId = this.accountId;
    this.ChangeStatus(this.multiUpdateModel);
  }

  ChangeStatus(data: any) {
    this.kendogridHelper.showLoadingIndicator();
    this.contactService.addressesStatusUpdate(data).subscribe(response => {
      this.kendogridHelper.hideLoadingIndicator();
      this.toastr.success('Status Updated Successfully');
      this.onRefreshGridData();
    });
  }

  onViewAddress(dataItem: any): void {
    this.addressId = dataItem.addressId;
    this.onOpenDialog();
  }

  onAddNewAddress(): void {
    this.addressId = null;
    this.onOpenDialog();
  }

  onToggleChange(value: string) {
    this.statusValue = value;
    this.isUpdate = false;
    this.onRefreshGridData();
  }

  onSelectedKeysChange(currentList) {
    const len = this.rowSelectionList.length;
    if (len === 0) {
      this.selectAllState = 'unchecked';
    } else if (len > 0 && len < this.addressList.length) {
      this.updateSelectList(currentList);
      this.selectAllState = 'indeterminate';
    } else {
      this.updateSelectList(currentList);
      this.selectAllState = 'checked';
    }
  }

  onSelectAllChange(checkedState: SelectAllCheckboxState) {
    if (checkedState === 'checked') {
      this.rowSelectionList = this.addressList.map((item) => item.addressTypeId !== 1 ? item.addressId : null);
      this.selectAllState = 'checked';
    } else {
      this.rowSelectionList = [];
      this.selectAllState = 'unchecked';
    }
  }

  updateSelectList(currentList: any) {
    const availableAddress = this.addressList.filter(item => currentList.includes(item.addressId) && item.addressType == 'Primary');
    if (availableAddress && availableAddress.length > 0) {
      this.rowSelectionList = this.rowSelectionList.filter(item => item !== availableAddress[0].addressId);
    }
  }

  getTrimSting(value: string) {
    return value.trim();
  }
}
